import moment from "moment";
import { useContext, useEffect, useState } from "react";
import useCurrencyPairs from "../../api/hooks/useCurrencyPairs";
import useCustomerCurrencies from "../../api/hooks/useCustomerCurrencies";
import useHolidays from "../../api/hooks/useHolidays";
import { getListOfSettlementCurrenciesForPaymentOrders } from "../../api/NetworkingCurrencies";
import AppContext from "../../App.context";
import { formatDate, formatToCurrency, formatValidInputClass, validInputClass } from "../../helpers/FormatHelper";
import { getResource } from "../../helpers/ResourcesHelper";
import DatePicker from "../inputs/DatePicker";
import Dropdown from "../inputs/Dropdown";
import { ICustomerCurrencies } from "../orders/currencyDetails/CurrencyDetails";
import { usePaymentTransactionContext } from "./PaymentTransactionContext";

export const TransactionInfo = (props: any) => {

  const { showLoadingModal, hideLoadingModal } = useContext(AppContext);

  const [customerCurrencies] = useCustomerCurrencies();
  const [settlementMethods, setSettlementMethods] = useState([{ label: getResource('SelectSettlementMethod'), value: '' }]);
  const [currencyPairs] = useCurrencyPairs();

  const [holidays] = useHolidays();

  const {
    buyCurrency,
    setBuyCurrency,
    buyCurrencyInfo,
    setBuyCurrencyInfo,
    sellCurrency,
    sellCurrencyInfo,
    setSellCurrency,
    setSellCurrencyInfo,
    settlementMethod,
    setSettlementMethod,
    disbursementInfoAsParameter,
    fromBalances,
    validateInput,
    valueDate,
    setValueDate,
    setCustomerRate
  } = usePaymentTransactionContext();

  const [momentValueDate, setMomentValueDate] = useState(undefined);
  const [momentStartDate, setMomentStartDate] = useState(undefined);
  const [momentEndDate, setMomentEndDate] = useState(undefined);

  const userSession = JSON.parse(localStorage.getItem('UserSession')!);
  const customerId = JSON.parse(localStorage.getItem('UserSession')!)['CustomerID'];

  let defaultSettlementInstrument = ''
  if (userSession && userSession['DefaultSettlementInstrument']) {
    defaultSettlementInstrument = userSession['DefaultSettlementInstrument']
  }

  useEffect(() => {
    let paymentCurrencies = (customerCurrencies as ICustomerCurrencies).payment
    console.log('paymentCurrencies ', paymentCurrencies)
    if (paymentCurrencies !== undefined && Array.isArray(paymentCurrencies.filter(x => x.CurrencyID === buyCurrency))) {
      let buyCurrencyObj = paymentCurrencies.filter(x => x.CurrencyID === buyCurrency)[0]
      console.log('buyCurrencyObj ', buyCurrencyObj)
      setBuyCurrencyInfo(buyCurrencyObj)
    } else {
      setBuyCurrencyInfo({})
    }
  }, [customerCurrencies, buyCurrency]);

  useEffect(() => {
    const load = async () => {
      showLoadingModal()
      let response = await getListOfSettlementCurrenciesForPaymentOrders(customerId, sellCurrency)
      hideLoadingModal()
      if (response.items) {
        const formattedSettlements = response.items.map((c: any) => {
          const details = c.details.map((d: any) => {
            if (d.label === 'Balance') {
              return { ...d, description: formatToCurrency(d.description, sellCurrency) }
            }
            return d;
          });
          return ({ ...c, label: c.name, details: details });
        });
        formattedSettlements.push({ label: getResource('SelectSettlementMethod'), value: '' });
        setSettlementMethods(formattedSettlements);
        let indexDefault = -1;

        let isDefault = false;
        formattedSettlements.forEach((element: any, index: number) => {
          if (element.value.includes(defaultSettlementInstrument) && !isDefault) {
            indexDefault = index;
            isDefault = true;
          }
        });
        if (indexDefault >= 0) setSettlementMethod(formattedSettlements[indexDefault].value)
        else setSettlementMethod('');
      } else {
        setSettlementMethods([])
      }
    }

    if (sellCurrency === '') {
      return
    }

    load()
  }, [sellCurrency, customerId, defaultSettlementInstrument]);

  useEffect(() => {
    if (buyCurrency !== '' && sellCurrency !== '') {
      getValueDateForCalendar();
    }
  }, [buyCurrency, sellCurrency]);

  const onChangeValueDate = (date: any, dateString: string) => {
    setMomentValueDate(date);
    setValueDate(dateString);
  };

  const getValueDateForCalendar = () => {
    if (sellCurrency !== '' && buyCurrency !== '') {
      let cutoffTime = localStorage.getItem('CutoffTime');

      if (cutoffTime === null) {
        cutoffTime = '12:00';
      }

      let currentDate = new Date();
      let startDate = new Date(localStorage.getItem('SystemDate')!);

      startDate.setHours(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds(), 0);

      let hourStart = getTimehhmm(startDate);
      if (hourStart > cutoffTime) {
        startDate.setDate(startDate.getDate() + 1);
      }

      let endDate = calculateEndDate(startDate, sellCurrency, buyCurrency);

      setMomentStartDate(moment(startDate) as any);
      setMomentEndDate(moment(endDate) as any);

      setMomentValueDate(moment(startDate) as any);
      setValueDate(formatDate(startDate));
    }
  };

  const getTimehhmm = (datetime: Date) => {
    let hours = datetime.getHours();
    let minutes = datetime.getMinutes();
    let hoursText = hours.toString();
    let minutesText = minutes.toString();
    if (hours < 10) {
      hoursText = '0' + hours;
    }
    if (minutes < 10) {
      minutesText = '0' + minutes;
    }
    return hoursText + ':' + minutesText;
  }

  const disabledDate = (current: any) => {
    return current < momentStartDate! || current > momentEndDate! || moment(current).day() === 0 || moment(current).day() === 6;
  };

  const calculateEndDate = (startDate: string | Date, buyCurrencyCalculate: string, sellCurrencyCalculate: string) => {
    //Get spot days
    let spotDays = 2;
    //@ts-ignore
    if (currencyPairs[buyCurrencyCalculate + sellCurrencyCalculate] !== undefined) {
      //@ts-ignore
      spotDays = currencyPairs[buyCurrencyCalculate + sellCurrencyCalculate].SpotDays;
    }
    //Recent holidays
    var holidaysHelper = [];
    for (var i = 0; i < holidays.length; i++) {
      //@ts-ignore
      if (
        //@ts-ignore
        holidays[i].CurrencyID === 'ANY' ||
        //@ts-ignore
        holidays[i].CurrencyID === sellCurrency ||
        //@ts-ignore
        holidays[i].CurrencyID === buyCurrencyCalculate
      ) {
        //@ts-ignore
        holidaysHelper.push(holidays[i].Date);
      }
    }

    //Calculate end date
    var endDate = new Date(startDate);
    var daysToAdd = spotDays;

    while (daysToAdd > 0) {
      endDate.setDate(endDate.getDate() + 1);
      if (endDate.getDay() === 6 || endDate.getDay() === 0 || holidaysHelper.includes(formatDate(endDate))) {
        //Nothing at all
      } else {
        daysToAdd--;
      }
    }
    return endDate;
  }

  const onChangeSettlement = (item: any) => {
    console.log('onChangeSettlement ', item)
    if (Array.isArray(item.details) && item.details.length > 0) {
      setSettlementMethod(item.details[0].description)
    } else {
      setSettlementMethod(item.value)
    }
  }

  return <>
    <div className="row">
      <span className="input-label">{getResource('Form.Label.BuyCurrency')}</span>
    </div>
    <div className="row">
      <Dropdown name="buyCurrency" title={getResource('SelectCurrencyBuy')}
        list={(customerCurrencies as ICustomerCurrencies).payment}
        onChange={(item: any) => { setBuyCurrency(item.value); setBuyCurrencyInfo(item); setCustomerRate(0) }}
        select={buyCurrencyInfo}
        disabled={disbursementInfoAsParameter}
        className={validateInput ? formatValidInputClass(validInputClass(buyCurrency)) : ''}
      />
    </div>
    <div className="row">
      <span className="input-label">{getResource('Form.Label.SellCurrency')}</span>
    </div>
    <div className="row">
      <Dropdown
        name="sellCurrency" title={getResource('SelectCurrencySell')}
        list={(customerCurrencies as ICustomerCurrencies).settlement}
        onChange={(item: any) => { setSellCurrency(item.value); setSellCurrencyInfo(item); setCustomerRate(0) }}
        select={sellCurrencyInfo}
        className={validateInput ? formatValidInputClass(validInputClass(sellCurrency)) : ''}
      />
    </div>
    <div className="row">
      <span className="input-label">{getResource('Form.Label.ValueDate')}</span>
    </div>
    <div className="row">
      <DatePicker key="app-datepicker-valuedate"
        onChange={onChangeValueDate}
        value={momentValueDate}
        disabledDate={disabledDate}
        className={validateInput ? formatValidInputClass(validInputClass(valueDate)) : ''} />
    </div>
    <div className="row">
      <span className="input-label">{getResource('Form.Label.SettlementMethod')}</span>
    </div>
    <div className="row">
      <Dropdown
        name="settlementMethodOrder"
        title={getResource('SelectSettlementMethod')}
        settlementMode={true}
        list={settlementMethods}
        onChange={onChangeSettlement}
        select={{ value: settlementMethod }}
        disabled={sellCurrency === '' || fromBalances}
        className={validateInput ? formatValidInputClass(validInputClass(settlementMethod)) : ''}
      />
    </div>
  </>
}